import dJSON from 'dirty-json';

const moduleSelector = '.tabbed-content';

function slugify(str) {
  return str.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_]+/g, '-');
}

(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove();

      const { data } = dJSON.parse(query.data);
      if (!data?.length) return;

      const tabsContainer = query.querySelector('.tabbed-content__tabs');
      const contentContainer = query.querySelector('.tabbed-content__wrapper');

      data.forEach((item, i) => {
        const slug = slugify(item.tab_name);

        tabsContainer.insertAdjacentHTML('beforeend', /* html */ `
          <a href="#${slug}" class="tabbed-content__tab" data-index="${i}">${item.tab_name}</a>
        `);

        const uspHtml = item.USP?.length ? /* html */ `
          <div class="tabbed-content__usp">
            ${item.USP.map((usp) => /* html */ `
              <div class="tabbed-content__usp-item">
                <div class="tabbed-content__usp-icon">
                  <img src="${usp.usp_icon}" alt="" aria-hidden="true" role="presentation">
                </div>
                <div class="tabbed-content__usp-content">
                  <h3 class="tabbed-content__usp-title">${usp.usp_title}</h3>
                  <p class="tabbed-content__usp-text">${usp.usp_text}</p>
                </div>
              </div>
            `).join('')}
          </div>
        ` : '';

        contentContainer.insertAdjacentHTML('beforeend', /* html */ `
          <div class="tabbed-content__panel" data-index="${i}">
            <div class="content-section" data-alignment="left">
              <div class="content-section__wrapper">
                <h2 class="content-section__title">${item.title}</h2>
                <div class="content-section__text">${item.text}</div>
                <a href="${item.button_link}" class="btn-custom secondary">${item.button_text}</a>
              </div>
              <div class="content-section__image">
                <img src="${item.image}" alt="" role="presentation" aria-hidden="true">
              </div>
            </div>
            ${uspHtml}
          </div>
        `);
      });

      const tabs = tabsContainer.querySelectorAll('.tabbed-content__tab');
      const panels = contentContainer.querySelectorAll('.tabbed-content__panel');

      const activate = (index) => {
        tabs.forEach((t, i) => t.classList.toggle('active', i === index));
        panels.forEach((p, i) => p.classList.toggle('active', i === index));
      };

      const activateFromHash = () => {
        const hash = window.location.hash.slice(1);
        if (!hash) { activate(0); return; }
        const match = [...tabs].findIndex((t) => t.getAttribute('href') === `#${hash}`);
        activate(match >= 0 ? match : 0);
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          const href = tab.getAttribute('href');
          window.history.pushState(null, '', href);
          activateFromHash();
        });
      });

      window.addEventListener('hashchange', activateFromHash);
      activateFromHash();
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
